
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AppCommonModule } from '../common.module';
import { DashboardViewComponent } from '../components/views/dashboard/view-dashboard.component';
import { PrivacyComponent } from './privacy.component';

@Component({
  selector: 'app-privacy-page',
  templateUrl: './privacy.page.html',
  styleUrls: ['./privacy.page.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AppCommonModule,
    DashboardViewComponent,
    PrivacyComponent,
  ],
})
export class PrivacyPage {

}
